import React from 'react';

function TodosError() {
  return <p>Ha ocurrido un error, vuelve a intentarlo mas tarde...</p>;
}

export { TodosError };